// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-block {
    margin-bottom: 20px;
}

.swiper-container {
    width: 100%;
    height: 300px;
    margin: 0 auto;
}

.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}

.slide-preview {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
}

button {
    margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/blank-slideshow/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".swiper-block {\n    margin-bottom: 20px;\n}\n\n.swiper-container {\n    width: 100%;\n    height: 300px;\n    margin: 0 auto;\n}\n\n.swiper-slide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.slide-preview {\n    position: relative;\n    display: inline-block;\n    margin-bottom: 10px;\n}\n\nbutton {\n    margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
